var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustificationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7998 20.1331V30.5334H30.4004L31.8672 34.1331L30.2666 34.9329L25.2002 30.5334H7.2002V20.1331L20 10.3997L32.7998 20.1331ZM24.3037 23.8059C23.8466 23.6919 23.3914 23.9779 23.1738 24.3958C22.9377 24.8497 22.6064 25.252 22.1992 25.5725C21.5668 26.0701 20.7862 26.3432 19.9814 26.3489C19.1769 26.3544 18.3931 26.0924 17.7539 25.6038C17.3422 25.289 17.0052 24.8914 16.7627 24.4407C16.5394 24.0258 16.0805 23.7463 15.625 23.8665C15.1695 23.9868 14.8918 24.4583 15.083 24.8889C15.4439 25.7007 16.0039 26.4141 16.7168 26.9592C17.6571 27.6781 18.8106 28.0642 19.9941 28.0559C21.1775 28.0475 22.3249 27.6452 23.2549 26.9133C23.9599 26.3584 24.5099 25.6372 24.8594 24.8206C25.0444 24.3875 24.7607 23.92 24.3037 23.8059ZM16 17.8665C15.1165 17.8665 14.4007 18.5827 14.4004 19.4661C14.4004 20.3497 15.1163 21.0667 16 21.0667C16.8836 21.0665 17.5996 20.3497 17.5996 19.4661C17.5993 18.5827 16.8834 17.8666 16 17.8665ZM24 17.8665C23.1165 17.8665 22.4007 18.5827 22.4004 19.4661C22.4004 20.3497 23.1163 21.0667 24 21.0667C24.8836 21.0665 25.5996 20.3497 25.5996 19.4661C25.5993 18.5827 24.8834 17.8666 24 17.8665ZM38 18.6663L35.8662 20.3997L20 8.39966L4.13379 20.3997L2 18.6663L20 4.80005L38 18.6663Z",
    fill: "url(#paint0_linear_2221_11235)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2221_11235",
    x1: 20,
    y1: 4.80005,
    x2: 20,
    y2: 34.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#1155C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustificationLogo);
export default __webpack_public_path__ + "static/media/justificationLogo.2829fb980a9ed4693ad7ef0930f9ad93.svg";
export { ForwardRef as ReactComponent };